<template>
  <div style="background: #f6f6f7">
    <pcHeaders></pcHeaders>
    <div style="display: flex; justify-content: center; background: #fff; width: 100%; height: 100px; align-items: center">
      <img style="width: 1000px; height: 80px" src="../../assets/images/lc04.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
    </div>
    <div class="flex" style="justify-content: center">
      <div class="bannerrrr">
        <div class="flex" style="font-size: 16px; justify-content: space-between; margin-top: 30px">
          <div class="flex">
            <div>
              <img style="margin-top: 2px" src="../../assets/images/02_03.png" alt="铜仁学院省级专业技术人员继续教育培训平台" />
            </div>
            <div style="margin-left: 5px; font-size: 18px">核对订单信息</div>
          </div>
        </div>

        <div style="margin-top: 25px">
          <el-table :data="calssInfo.classList" style="width: 100%">
            <el-table-column prop="className" label="班级名称" width="580" align="center"> </el-table-column>

            <el-table-column prop="zyName" label="专业分类" width="380" align="center"> </el-table-column>
            <el-table-column prop="credit" label="学时" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.credit.toFixed(1) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格" align="center"> </el-table-column>
          </el-table>
<div style="color: #ff9f53;margin-top: 10px;font-size: 18px;" v-if="this.$route.query.orderId&&this.$route.query.orderId!=''">*离开此页面无法参加拼团活动，
  拼团有效期24小时超时则无法参加拼团活动</div>
          <div
            style="
              margin-top: 15px;
              display: flex;
              justify-content: space-between;
              border-bottom: 1px dotted #ccc;
              font-size: 18px;
              background: #fff;
              height: 80px;
              line-height: 80px;
              padding-right: 15px;
            "
          >
            <div></div>
            <div>
              订单金额：<span style="color: #ef1300; font-size: 22px"
                ><span style="font-size: 16px">￥</span>{{ calssInfo.totalPrice }}</span
              >
            </div>
          </div>

          <!-- 账户抵扣方式 -->
          <div
            style="
              display: flex;
              justify-content: space-between;
              border-bottom: 1px dotted #ccc;
              font-size: 18px;
              background: #fff;
              height: 130px;
              padding-right: 15px;
              padding-top: 20px;
            "  v-if="showSelet"
          >
            <div></div>
            <!-- 账户余额抵扣 -->
            <div>
              <el-checkbox :value="deductType === 'amount'" @change="handleDeduction('amount')">
                账户余额抵扣：
                <span style="color: #ef1300; font-size: 22px">
                  <span style="font-size: 16px">￥</span>{{Math.min(calssInfo.balance, calssInfo.totalPrice).toFixed(2)}}
                </span>
              </el-checkbox>
              <div style="font-size: 14px; color: #797979; margin-top: 10px; text-align: right">
                <span v-if="calssInfo.balance > 0">剩余余额：{{ deductionNum.toFixed(2) }}</span>
              </div>
            </div>
          </div>
          <!-- <div
            style="
              display: flex;
              justify-content: space-between;
              border-bottom: 1px dotted #ccc;
              font-size: 18px;
              background: #fff;
              height: 130px;
              padding-right: 15px;
              padding-top: 20px;
            " v-if="showIntegral"
          >
            <div></div>
            账户积分抵扣
            <div  style="margin-top: 10px">
              <el-checkbox :value="deductType === 'integral'" @change="handleDeduction('integral')">
                账户积分抵扣：
                <span style="color: #ef1300; font-size: 22px">
                  <span style="font-size: 16px">￥</span>{{Math.min((calssInfo.surplusIntegral / 30), calssInfo.totalPrice).toFixed(2)}}
                </span>
              </el-checkbox>
              <div style="font-size: 14px; color: #797979; margin-top: 10px; text-align: right">
                <span v-if="calssInfo.surplusIntegral > 0">剩余积分：{{ deductionNum1 }}</span>
              </div>
            </div>
          </div> -->
          <div
            style="
              display: flex;
              justify-content: space-between;
              border-bottom: 1px dotted #ccc;
              font-size: 18px;
              background: #fff;
              height: 80px;
              line-height: 80px;
              padding-right: 15px;
            "
          >
            <div></div>
            <div>
              应付金额：<span style="color: #ef1300; font-size: 22px"><span style="font-size: 16px">￥</span>{{ paymentNum }}</span>
            </div>
          </div>

          <div
            style="
              display: flex;
              justify-content: space-between;
              border-bottom: 1px dotted #ccc;
              font-size: 18px;
              background: #fff;
              height: 80px;
              line-height: 80px;
              padding-right: 15px;
              padding-top: 15px;
            "
          >
            <div></div>
            <div class="payBtn" @click="purchase">提交支付</div>
          </div>
        </div>
      </div>
    </div>

    <pcBottom></pcBottom>
  </div>
</template>
<script>
import pcHeaders from '../component/head.vue';
import pcBottom from '../component/bottom.vue';
import { toOrderConfirm, toGenerateOrder } from '@/api/pay.js';

export default {
  components: {
    pcHeaders,
    pcBottom
  },
  data() {
    return {
      calssInfo: {}, // 订单数据
      deductType: '', // 'amount' 或 'integral'，控制单选
      paymentNum: 0, // 实付金额
      deductionNum: 0, // 剩余余额或积分
      deductionNum1: 0, // 剩余积分
      usedIntegral: 0, // 实际使用的积分
      showSelet: false, // 是否显示余额选项
      showIntegral: false, // 是否显示积分选项
      falg: true,
      orderId:''
    };
  },
  methods: {
    // 处理抵扣方式选择
    handleDeduction(type) {
 
      if (this.deductType === type) {
        this.deductType = ''; 
      } else {
        this.deductType = type; 
      }

      this.calculatePayment();
    },
    calculatePayment() {
      const total = this.calssInfo.totalPrice;
        this.deductionNum1 = this.calssInfo.surplusIntegral;
      if (this.deductType === 'amount') {
        if (this.calssInfo.balance >= total) {
          this.deductionNum = parseFloat((this.calssInfo.balance - total).toFixed(2));
          this.paymentNum = 0;
        } else {
          this.deductionNum = 0;
          this.paymentNum = parseFloat((total - this.calssInfo.balance).toFixed(2));
        }
        this.usedIntegral = 0;
      } else if (this.deductType === 'integral') {
        this.deductionNum = this.calssInfo.balance;
        const maxDeductibleByIntegral = this.calssInfo.surplusIntegral / 30;
        const actualDeduct = Math.min(maxDeductibleByIntegral, total);
        this.paymentNum = parseFloat((total - actualDeduct).toFixed(2));
        this.usedIntegral = actualDeduct * 30;
        this.deductionNum1 = parseFloat((this.calssInfo.surplusIntegral - this.usedIntegral).toFixed(2));
      } else {
        // 无选择
        this.paymentNum = parseFloat(total.toFixed(2));
        this.deductionNum = this.calssInfo.balance;
        this.deductionNum1 = this.calssInfo.surplusIntegral;
        this.usedIntegral = 0;
      }
    },

    // 提交支付
    purchase() {
      let data = {
        classIds: this.$route.query.classId,
        orderId: this.$route.query.orderId
      };

      // 设置抵扣类型
      if (this.deductType === 'amount') {
        data.derateType = '01'; // 余额抵扣
      } else if (this.deductType === 'integral') {
        data.derateType = '02'; // 积分抵扣
      } else {
        data.derateType = '03'; // 无抵扣
      }

      if (this.calssInfo.totalPrice === 0) {
        data.derateType = '01';
      }

      if (this.falg) {
        this.falg = false;
        toGenerateOrder(data)
          .then(res => {
            this.falg = true;
            if (res.data.data.code == '1') {
              this.$router.push({
                path: '/toPayOrder',
                query: { orderId: res.data.data.orderId }
              });
            } else if (res.data.data.code == '4') {
              this.$router.push({
                path: '/paySuccess',
                query: { orderId: res.data.data.orderId }
              });
            } else if (res.data.data.code == '3') {
              this.$message.error(res.data.data.msg);
            }
          })
          .catch(() => {
            this.falg = true;
          });
      }
    },

    // 获取订单确认信息
    toOrderConfirm() {
      const orderId = this.$route.query.orderId || '';
      toOrderConfirm({ classIds: this.$route.query.classId, orderId }).then(res => {
        if (res.data.data.code === '1') {
          this.calssInfo = res.data.data.data;
          this.paymentNum = this.calssInfo.totalPrice;
          this.deductionNum = this.calssInfo.balance;
          this.deductionNum1 = this.calssInfo.surplusIntegral;
          this.showSelet = this.calssInfo.balance > 0;
          this.showIntegral = this.calssInfo.surplusIntegral > 0;
          this.deductType = '';
        } else {
          this.$message.error(res.data.data.msg);
          this.$router.back();
        }
      });
    }
  },
  created() {
    this.toOrderConfirm();
 
  }
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.flex {
  display: flex;
}
.bannerrrr {
  background: #f6f6f7;
  padding: 20px 0;
  width: 1400px;
  min-height: 720px;
  font-family: Regular;
  .goBtn {
    width: 160px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    background: #ff9f53;
    font-size: 15px;
    cursor: pointer;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
  }
  .payBtn {
    width: 121px;
    height: 32px;
    cursor: pointer;
    text-align: center;
    line-height: 32px;
    background: #fd9d57;
    color: #fff;
  }
}
::v-deep {
  .el-radio {
    margin-right: 0 !important;
  }
}
</style>
